import React from 'react';
import { DisplayInputComponentProps } from '../../types';
import type { FieldValues } from 'react-hook-form';
import { useWatch, FieldPath } from 'react-hook-form';
import { JRCInputImage, JRCInputImageProps } from 'jamespot-react-components';

export const InputImage = <TFieldValues extends FieldValues>(props: DisplayInputComponentProps<TFieldValues>) => {
    const tokenName: FieldPath<TFieldValues> = 'token' as FieldPath<TFieldValues>;
    const token = useWatch({ name: tokenName, control: props.control });
    const additionalProps: Partial<Pick<JRCInputImageProps, 'dzDimensions'>> = {};

    if ('image' === props.widget.type && props.widget.params?.avatar) {
        additionalProps.dzDimensions = { width: 170, height: 170 };
    }

    return <JRCInputImage {...props} token={token} aspectRatio={1} {...additionalProps} />;
};
